import { Controller } from '@hotwired/stimulus'

// Live investment totals on the customer proposal: the committed base plus
// whichever optional add-ons the prospect ticks. The bases are already the
// discounted figures; add-ons add on top at full price, since add-ons do not
// interact with discounts. Display only; the picks are not sent anywhere
// until the proposal is accepted (a later ticket). Every amount arrives and is
// summed as whole cents, so no money arithmetic happens in floating point, and
// is formatted the way SalesHelper#quote_amount does: whole dollars unless
// there are cents. The rate after promotions and the struck gross figures move
// by the same add-on amount so they never go stale against the live net totals.
export default class extends Controller {
  static targets = ['toggle', 'monthlyTotal', 'oneTimeTotal', 'annualTotal', 'steadyMonthly', 'monthlyGross', 'oneTimeGross']
  static values = {
    monthlyBaseCents: Number,
    oneTimeBaseCents: Number,
    annualBaseCents: Number,
    steadyMonthlyBaseCents: Number,
    grossMonthlyBaseCents: Number,
    grossOneTimeBaseCents: Number
  }

  connect() {
    this.recalc()
  }

  recalc() {
    let addOnMonthly = 0
    let addOnOneTime = 0

    this.toggleTargets.forEach((box) => {
      if (!box.checked) return
      addOnMonthly += parseInt(box.dataset.monthlyCents || '0', 10)
      addOnOneTime += parseInt(box.dataset.oneTimeCents || '0', 10)
    })

    this.setAmount(this.monthlyTotalTargets, this.monthlyBaseCentsValue + addOnMonthly)
    this.setAmount(this.oneTimeTotalTargets, this.oneTimeBaseCentsValue + addOnOneTime)
    this.setAmount(this.annualTotalTargets, this.annualBaseCentsValue + addOnMonthly * 12)
    this.setAmount(this.steadyMonthlyTargets, this.steadyMonthlyBaseCentsValue + addOnMonthly)
    this.setAmount(this.monthlyGrossTargets, this.grossMonthlyBaseCentsValue + addOnMonthly)
    this.setAmount(this.oneTimeGrossTargets, this.grossOneTimeBaseCentsValue + addOnOneTime)
  }

  setAmount(elements, cents) {
    elements.forEach((el) => { el.textContent = this.currency(cents) })
  }

  currency(cents) {
    const whole = cents % 100 === 0
    return (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2
    })
  }
}
